import './App.css';
import Body from './components/body/body';
import Feedback from "./components/feedback/feedback"
import Book from "./components/book/book"
import Gallery from "./components/gallery/gallery"
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import WCU from './components/wcu/wcu';
import Video from "./components/video/video"

function App() {
  return (
    <div className="App">
      <Header id="home" />
      <Body />
      <WCU />
      <Video />
      <Feedback />
      <Book />
      <Gallery />
      <Footer />
    </div>
  );
}

export default App;
